import { render, staticRenderFns } from "./coData2.vue?vue&type=template&id=37496d22&scoped=true&"
import script from "./coData2.vue?vue&type=script&lang=js&"
export * from "./coData2.vue?vue&type=script&lang=js&"
import style0 from "./coData2.vue?vue&type=style&index=0&id=37496d22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37496d22",
  null
  
)

export default component.exports